import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

export interface QrPopupData {
  location: string; // A3 code
}

const QR_BY_COUNTRY: Record<string, string> = {
  global: './assets/img/qrs/pa-qr.svg',
  PAK: './assets/img/qrs/pa-qr-pak.svg',
  IDN: './assets/img/qrs/pa-qr-idn.svg?v2',
};

@Component({
  templateUrl: './qr-modal-footer.component.html',
  styleUrls: ['./qr-modal-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatDialogModule],
})
export class QrModalFooterComponent {
  public url = QR_BY_COUNTRY[this._data.location] || QR_BY_COUNTRY['global'];

  constructor(
    @Inject(MAT_DIALOG_DATA)
    private readonly _data: QrPopupData,
  ) {}
}
